exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".my-dept-select-tree[data-v-7d78fd02] {\n  height: 350px;\n  overflow-y: scroll;\n}\n", ""]);

// exports
